import { getUserData } from './API';

// Helper function to determine locale from story or user data
const getLocaleForAssessment = (story) => {
  // Check if story has Spanish tags
  if (story && story.tags) {
    const hasSpanishTag = story.tags.some(tag => 
      tag === "ES-MX" || tag === "es-mx" || tag === "ES_MX"
    );
    if (hasSpanishTag) {
      return "es-mx";
    }
  }
  
  // Fall back to user's locale setting
  const userData = getUserData();
  return userData.locale || userData.bilingualLocale || "en-us";
};

const storeTestletItemTextResponse = (speech, state, phrase, phraseMetadata, phraseIndex, type, callback, story = null) => {
  const locale = getLocaleForAssessment(story);

  speech.storeTestletItemResponse(
    state.activityId, // activityId
    getUserData().userId, // studentId
    getUserData().actualGrade, // gradeLevel
    state.assessmentTestletId, // testletId
    phraseMetadata.itemId, // itemId
    type, // testletType
    phrase || "", // expectedText
    state.textResponse && 
      state.textResponse[phraseIndex] && 
      state.textResponse[phraseIndex].length > 0 ? 
        state.textResponse[phraseIndex][state.textResponse[phraseIndex].length - 1] : 
        null, // actualText
    callback, // callback
    locale // locale
  );
}

const storeTestletItemArrayResponse = (speech, state, expectedArray, phraseMetadata, phraseIndex, type, callback, story = null) => {
  const locale = getLocaleForAssessment(story);
  
  speech.storeTestletItemResponse(
    state.activityId, // activityId
    getUserData().userId, // studentId
    getUserData().actualGrade, // gradeLevel
    state.assessmentTestletId, // testletId
    phraseMetadata.itemId, // itemId
    type, // testletType
    JSON.stringify(expectedArray), // expectedText
    state.textResponse && 
      state.textResponse[phraseIndex] && 
      state.textResponse[phraseIndex].length > 0 ? 
        state.textResponse[phraseIndex][state.textResponse[phraseIndex].length - 1] : 
        null, // actualText
    callback, // callback
    locale // locale
  );
}

const triggerRelevelComplete = (recordingMeta, speech, state, phraseMetadata, type, shouldUpLevel, shouldDownLevel, callback) => {
  speech.onAosTriggerRelevelComplete(
    recordingMeta,
    state.activityId, 
    getUserData().userId, 
    getUserData().actualGrade, 
    state.assessmentTestletId, 
    phraseMetadata.itemId, // itemId
    type,
    shouldUpLevel,
    shouldDownLevel,
    callback
  );
}

const storeTestletItemAudioResponse = (speech, state, phrase, transcript, phraseMetadata, callback, story = null) => {
  const locale = getLocaleForAssessment(story);
  
  speech.storeTestletItemResponse(
    state.activityId, // activityId
    getUserData().userId, // studentId
    getUserData().actualGrade, // gradeLevel
    state.assessmentTestletId, // testletId
    phraseMetadata.itemId, // itemId
    "audio", // itemType
    phrase, // expectedText
    transcript, // actualText
    callback, // callback
    locale // locale
  );
}

// Formative only. The caller resolves actualText from page coordinates
// (textResponse[pageIndex][currentPhraseIndex]); the lookup above reads
// textResponse[overallPhraseIndex][last], which returns a neighbouring slot once a page
// holds more than one phrase -- that shipped a bucketing board under a sequencing item's id.
// Legacy nonAudio keeps the lookup above: it is one phrase per page, where the two agree.
const storeTestletItemEncodedResponse = (speech, state, phrase, phraseMetadata, actualText, type, callback, story = null) => {
  const locale = getLocaleForAssessment(story);

  speech.storeTestletItemResponse(
    state.activityId, // activityId
    getUserData().userId, // studentId
    getUserData().actualGrade, // gradeLevel
    state.assessmentTestletId, // testletId
    phraseMetadata.itemId, // itemId
    type, // testletType
    phrase || "", // expectedText
    actualText ?? null, // actualText
    callback, // callback
    locale // locale
  );
}

export default {
  storeTestletItemTextResponse,
  storeTestletItemEncodedResponse,
  storeTestletItemArrayResponse,
  triggerRelevelComplete,
  storeTestletItemAudioResponse,
}